/* apps/viewer/src/app/toc-items/comments-module/comment/comment.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
:host {
  font-size: 14px;
  width: 100%;
}
.comment-card {
  border-color: #596643;
  border-style: solid;
  border-width: 1px 1px 1px 8px;
  margin-bottom: 10px;
  padding: 10px;
}
.comment-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.comment-status {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.comment-priority {
  align-items: center;
  display: flex;
}
.comment-priority mat-icon {
  margin-right: 10px;
}
.comment-code {
  align-items: center;
  display: flex;
  font-weight: bold;
  gap: 5px;
  margin-right: 20px;
}
.comment-code .report-hidden {
  display: none;
}
.comment-menu {
  align-items: center;
  display: flex;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 30px;
}
.comment-title {
  font-weight: 700;
  line-break: anywhere;
  margin-top: 10px;
}
.comment-title,
.comment-paragraphs {
  word-break: break-word;
}
.comment-paragraphs {
  margin: 10px 0 0;
}
.comment-content {
  line-break: anywhere;
  white-space: pre-line;
}
.comment_infos {
  font-size: 12px;
  font-weight: normal;
  margin-top: 10px;
}
.clickable {
  cursor: pointer;
}
.comment-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.comment-infos {
  font-size: 12px;
}
.collapsible-content {
  display: none;
}
.collapsible-content.visible {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: unset;
  padding: 10px 0 0;
  width: 100%;
}
.collapsible-content .info {
  display: flex;
  flex-wrap: wrap;
}
.collapsible-content .info .key {
  flex: 0 0 200px;
  font-weight: bold;
  width: 200px;
}
.collapsible-content .info .value {
  flex: 1;
  min-width: 220px;
}
.medias-panel {
  flex-grow: 1;
  font-size: 14px;
  margin: 0;
  padding-inline-start: 20px;
}
.media-link {
  cursor: pointer;
  margin-right: 10px;
  text-decoration: underline;
  word-break: break-word;
}
.more-info {
  cursor: pointer;
}
@media print {
  .collapsible-content {
    display: unset;
  }
  .more-info {
    display: none;
  }
  .comment-menu {
    display: none;
  }
}
/*# sourceMappingURL=comment.component.css.map */
